import { Box, Text, VStack, type BoxProps, SimpleGrid } from "@chakra-ui/react";
import React, { type ReactNode } from "react";
import Balancer from "react-wrap-balancer";
import { AnimationVideo } from "ui/animation-video";
import { ArrowLink } from "ui/link";

type PairProps = {
  align: "left" | "right";
  eyebrow?: string;
  title: string;
  content: ReactNode;
  actionTitle?: string;
  actionHref?: string;
  animationWebm: string;
  animationMp4: string;
  animationPoster: string;
  animationBorderColor?: BoxProps["borderColor"];
  // eslint-disable-next-line react/boolean-prop-naming
  hideControls?: boolean;
  isLooped?: boolean;
};

export function PairVideo({
  align,
  eyebrow,
  title,
  content,
  actionTitle,
  actionHref,
  animationWebm,
  animationMp4,
  animationPoster,
  animationBorderColor,
  hideControls,
  isLooped,
}: PairProps) {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} gap={{ base: 8, md: 12, lg: 24 }} alignItems="center">
      <Box order={{ base: 1, md: align === "left" ? 1 : 2 }}>
        {eyebrow && (
          <Text mb={4} fontSize={{ base: "sm", md: "md" }} textStyle="uppercase">
            {eyebrow}
          </Text>
        )}

        <Text as="h3" mb={5} textStyle="h4" whiteSpace="pre-wrap">
          <Balancer>{title}</Balancer>
        </Text>

        <VStack spacing={7} mb={6} align="flex-start" fontSize="lg">
          {content}
        </VStack>

        {actionHref && actionTitle && (
          <ArrowLink href={actionHref} size="lg" variant="grass">
            {actionTitle}
          </ArrowLink>
        )}
      </Box>

      <Box order={{ base: 2, md: align === "left" ? 2 : 1 }}>
        <AnimationVideo
          webm={animationWebm}
          mp4={animationMp4}
          poster={animationPoster}
          borderColor={animationBorderColor}
          hideControls={hideControls}
          isLooped={isLooped}
        />
      </Box>
    </SimpleGrid>
  );
}
